import { RequestStatus } from 'clickNgo/configs/service/common'

import { IJbpSettings } from './models/jbpSettings'
import { IJBPSettingsState } from './models/state'

const initialJBPSettings: IJbpSettings = {
  accessDeniedSettings: null,
  amplifyDataInsightsHandbook: '',
  amplifyDataInsightsTraining: '',
  commitmentCompletenessThreshold: 0,
  compensationDaysRange: 0,
  currentFQuarter: 1,
  currentFYear: 0,
  distributorExtendedPlanning: 0,

  entryId: 0,
  exportHRActualsMappings: [],
  exportMIFReport: [],
  exportMPSSummaryReportV2: [],
  exportMasterDealerReport: [],
  exportTopPartnerSummaryReport: [],
  exportSalesTeamRequests: [],
  qbrGuideLinks: [],
  fYear: 0,
  fQuarter: 1,
  fDateActuals: '',
  fYearActuals: 0,
  fQuarterActuals: 1,
  fQuarterActualsPercentage: 0,
  finSobPlanQuarterlyChecks: 0,
  fYears: [],
  generatePDFOnBackend: 0,
  kiBusinessPriorities: [],
  keyObjectives: [],
  keyObjectiveTags: [],
  mdfToolsLink: '',
  mscsProviderPLs: '',
  maintenanceSettings: null,
  pbmPerformanceActualsReport: [],
  pbmPerformanceInitiativesReport: [],
  pbmToPartnerCheckEnabled: 0,
  psLifecyclePLs: '',
  psManageabilityPLs: '',
  psSecurityPLs: '',
  quickStartGuideLink: '',

  statisticsSettings: [],
  mdStatuses: [],
  mdEPStatuses: [],
  uamGuidePDFLink: '',
  reportsPartnerTypes: [],
  reportsFYears: [],
  dashboardsSettings: [],
  sobActualRequiredQuarters: [],
  offeringsList: [],

  stBusinessUnits: [],
  stRoles: [],

  isH2Review: 0,

  fYearELT: 0,
  fQuarterELT: 1,
}

export const initialState: IJBPSettingsState = {
  data: initialJBPSettings,
  message: '',
  status: RequestStatus.FULFILLED,
}
